/* @ngInject */
function CampaignsController ($scope, $rootScope, $translate, $q, UdsModalService, CampaignService, SegmentService, OnboardingDialogService, UiElementViewLogService, $state, AdminService, GroupService) {
  const getCreateCampaignDialogController = () => $q.when(import('./dialogs/create-campaign/create-campaign-dialog.controller'))
  $scope.pageTitle = ''
  $scope.totalCount = 0
  $scope.campaigns = []
  $scope.flags = {
    loading: false
  }

  const api = {
    getCreateCampaignDialogController,
    _setHeader,
    _openNewCampaignDialog,
    _getAllCampaigns,
    _openOnboardingDialog,
    _goToCalendarPage,
    _onFilter,
    _onSearch
  }

  this.getApi = () => api

  $scope.emptyState = {
    imgPath: 'empty-state-campaign-list',
    title: $translate.instant('campaignsModule.emptyState.campaignsList.title'),
    message: $translate.instant('campaignsModule.emptyState.campaignsList.message'),
    button: {
      type: 'primary',
      text: $translate.instant('campaignsModule.newCampaignBtn'),
      click: api._openNewCampaignDialog
    }
  }

  activate()

  function activate () {
    $scope.pageTitle = $translate.instant('campaignsModule.title')
    api._setHeader()
    $scope.flags.loading = true
    api._getAllCampaigns()
    api._openOnboardingDialog()
    SegmentService.track('campaign-home-view')
  }

  function _getAllCampaigns () {
    CampaignService.getAllCampaigns({})
      .then(campaigns => {
        $scope.campaigns = campaigns.rows
        $scope.totalCount = campaigns.count
        $scope.flags.loading = false
      })
  }

  $scope.getAllCampaigns = api._getAllCampaigns

  $translate.onReady(() => {
    api._setHeader()
  })

  function _goToCalendarPage () {
    $state.go('marketingCalendar', {
      originModule: 'campaigns'
    })
  }

  function _setHeader () {
    const showActiveAsDefaultValue = true

    const activeItems = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: !!showActiveAsDefaultValue,
      disabled: false
    }

    const filters = [
      {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: showActiveAsDefaultValue ? activeItems : null,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('actives'),
              value: false,
              icon: 'success',
              active: !!showActiveAsDefaultValue,
              disabled: false
            },
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'campaignStatus',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('status'),
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('waiting'),
              value: 'WAITING',
              icon: 'clock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('inProgress'),
              value: 'IN_PROGRESS',
              icon: 'target',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'campaignStatusRest',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: [],
        props: {
          multiple: true,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('campaignsModule.status.late'),
              value: 'LATE',
              icon: 'clock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('done'),
              value: 'FINISHED',
              icon: 'check',
              active: false,
              disabled: false
            }
          ]
        }
      },
      {
        name: 'usersGroup',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('usersGroupLabel'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'group',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (search, top, skip) => GroupService.getGroups(null, null, { searchTerm: search }, true)
      }
    ]

    $scope.headerToolbar = {
      rightButtons: [],
      search: {
        filters,
        onFilter: api._onFilter,
        onSearch: api._onSearch
      }
    }
    $scope.headerTitle = $translate.instant('campaignsModule.title')

    if ($rootScope.isUserSysAdminAdmin()) {
      $scope.headerToolbar.rightButtons.push({
        type: 'button-new',
        btnType: 'secondary',
        label: $translate.instant('calendar'),
        icon: 'calendar',
        onClick: api._goToCalendarPage,
        isNew: true,
        isNewLabel: $translate.instant('new')
      })
    }

    $scope.headerToolbar.rightButtons.push({
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('campaignsModule.newCampaignBtn'),
      onClick: api._openNewCampaignDialog
    })
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    CampaignService.getAllCampaigns(filters)
      .then(campaigns => {
        $scope.campaigns = campaigns.rows
        $scope.totalCount = campaigns.count
        $scope.flags.loading = false
      })
  }

  function _onSearch (search) {
    CampaignService.getAllCampaigns({ search })
      .then((response) => {
        $scope.campaigns = response.rows
        $scope.totalCount = response.count
        $scope.flags.loading = false
      })
  }

  function _openNewCampaignDialog () {
    getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      const createCampaignDialog = UdsModalService.createModal({
        controller: CreateCampaignDialogController,
        modalName: 'createCampaignDialog',
        data: {},
        onClose: () => {
          api._getAllCampaigns()
        }
      })

      createCampaignDialog.open()
    })
  }

  function _openOnboardingDialog () {
    UiElementViewLogService.getElementViewLog('campaigns-onboarding-dialog').then((elementViewLog) => {
      if (elementViewLog || $rootScope.isWorkflowPlan()) return

      const data = {
        title: $translate.instant('onboardingDialogCampaigns.title'),
        description: OnboardingDialogService.getCampaignsDescription(),
        slides: [
          { image: '/assets/img/onboarding/onboarding_campaigns.png' }
        ],
        primaryButton: {
          text: $translate.instant('getStarted'),
          onClick: () => {
            UiElementViewLogService.createElementViewLog('campaigns-onboarding-dialog')
          }
        }
      }

      OnboardingDialogService.openDialog(data)
    })
  }
}

export { CampaignsController }
